import $http from './http'
import config from './config'

export default {
    name: 'order',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    OrderList(data) {
        return $http.post(this.getUrl(`/Order/List`), data);
    },
    // tourorderdetail(id) {
    //     return $http.get(this.getUrl(`/OrderService/Details/${id}`));
    // },
    // OrderStateNum() {
    //     return $http.post(this.getUrl(`/Order/OrderStateNum`));
    // },
    // OrderInfo(id) {
    //     return $http.post(this.getUrl(`/Order/Details/${id}`));
    // },
    // Paydetails(id) {
    //     return $http.get(this.getUrl(`/Order/PayDetails/${id}`));
    // },
    // PayOrder(id) {
    //     return $http.get(this.getUrl(`/Order/PayOrder/${id}`));
    // },
    // CancelOrder(id) {
    //     return $http.get(this.getUrl(`/Order/Cancel/${id}`));
    // },
    // HotelDetail(id) {
    //     return $http.get(this.getUrl(`/Order/HotelDetail/${id}`));
    // },
    // TrainDetail(id) {
    //     return $http.get(this.getUrl(`/Order/GetOrderInfo/${id}`));
    // },
    // getBusinessByOrderId(id) {
    //     return $http.get(this.getUrl(`/Business/GetBusinessByOrderId/${id}`));
    // },
    // getOrderApprovalIsOk(data) {
    //     return $http.post(this.getUrl(`/OrderOperate/OrderApprovalIsOk`), data);
    // }
}




// WEBPACK FOOTER //
// ./src/apis/orderApis.js